module.exports = require("probe-image-size");